'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ChevronHeading = require('./components/ChevronHeading');

Object.defineProperty(exports, 'ChevronHeading', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ChevronHeading).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ../biblio-ui-glue/src/base/headings/lib/index.js
// module id = 650
// module chunks = 5 9